import { missingWidget } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';

const wrapContainerClass = 'custom-cards-container';

export default function customCards() {
  const widgetName = 'customCards';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof customCardsOpts === 'undefined' ? null : customCardsOpts;

  if (!widgetOpts) {
    $(`.${wrapContainerClass}`).remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: true,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    buyNowButton: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items, $widget);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });
}
function createCustomCards(widgetData, $widget) {
  $widget.find('.card-content').remove();

  $widget.find('.card-widget-item').each(function (x) {
    const { Title, Description, URL } = widgetData[x];
    const $cardItem = $(this);

    updateLinksAttributes(URL, Title, $cardItem);

    $cardItem.append('<div class="overlay"></div>');

    $cardItem.append(`
      <div class="card-content">
        <div class="hover-content">
          <div class="card-text">
            <div class="widget-title-wrapper">
              <h3 class="widget-title">${Title}</h3>
            </div>

            ${Description ? `<p class="widget-description">${Description}</p>` : ''}
          </div>

          <div class="arrow-container"></div>
        </div>
      </div>
    `);
  });
}
